import styles from './index.scss'
import { Button, SpinLoading } from 'antd-mobile'
import { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'umi'
import Layout from '@/libs/components/Layout'
import goTo from '@/libs/functions/goTo'
import { getUrlAllParams, getValue } from '@/libs/functions/getValue'

import { getMiniProgramChannelApi } from '@/libs/functions/appAdapter'
import { getStorage } from '@/libs/functions/onStorage'

import { orderGet } from '@/services'
import useCategorySet from '@/libs/hooks/useCategorySet'
import { hex2Rgb } from '@/libs/functions/tools'
import { SvgErrorIcon, SvgSuccessIcon } from '@/libs/components/Icon/svgIcon'
import useLang, { useModuleLang } from '@/libs/hooks/useLang'

function Result(props: any) {
  const [payTrans, promptTrans] = useModuleLang(['pay_util', 'prompt_util'])
  const channel = getStorage('channel')
  const channelApi = getMiniProgramChannelApi(channel)
  const [loading, setLoading] = useState(true)
  const [orderDetail, setOrderDetail] = useState({
    orderType: '',
  })
  let {
    orderNo,
    status = 'success',
    backUrl,
    payResult = '',
    errMsg = '',
  } = (getUrlAllParams() as any) || {}
  const onView = () => {
    goTo(`/order/orderRecord?status=`)
  }
  const isSuccess = payResult ? payResult === '0' : status === 'success'
  const text: any = {
    success: payTrans('paySuccess', '支付成功'),
    cancel: payTrans('payCancel', '支付取消'),
    fail: payTrans('payFailed', '支付失败'),
    failure: payTrans('payFailed', '支付失败'),
  }

  if (errMsg && payResult === '1') {
    switch (errMsg) {
      case 'requestPayment:ok':
        status = 'success'
        break
      case 'requestPayment:fail cancel':
        status = 'cancel'
        break
      default:
        status = 'failure'
    }
  }

  useEffect(() => {
    setLoading(true)
    if (channelApi && channelApi.goToPayResult) {
      channelApi.goToPayResult({ status })
    }
    orderGet({ orderNo: orderNo })
      .then((res: any) => {
        setOrderDetail(res)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [orderNo])

  const { categorySetting } = useCategorySet('TENANT', getValue('tenantCode'))
  const { base, buttonStyle } = categorySetting || {}
  const styleSetting = {
    '--primary-color-rgb': hex2Rgb(base?.primaryColor),
    '--primary-color': base?.primaryColor || '#f34242',
    '--primary-background-color': base?.primaryBackgroundColor,
    '--secondary-background-color1': base?.secondaryBackgroundColor1,
    '--text-color': base?.textColor,
    '--button-radius': (buttonStyle?.borderRadius || 0) + 'px',
    '--button-background-color':
      buttonStyle?.backgroundColorType === 'pure'
        ? buttonStyle?.backgroundColor1
        : `linear-gradient(${
            buttonStyle?.backgroundColorType === 'horizontalGradient'
              ? 'to right'
              : 'to bottom'
          }, ${buttonStyle?.backgroundColor1 || '#ffffff'}, ${
            buttonStyle?.backgroundColor2 || '#ffffff'
          })`,
    '--button-text-color': buttonStyle?.textColor,
  }

  return (
    <Layout
      style={styleSetting}
      title={payTrans('payResult', '支付结果')}
      backArrow={false}
      navBarStyle={{
        background: `var(--primary-background-color)`,
        color: `var(--text-color)`,
      }}
    >
      {!loading && (
        <div className={styles.result}>
          {isSuccess ? (
            <>
              <div className={styles.iconWrap}>
                <SvgSuccessIcon
                  color="var(--primary-color)"
                  backgroundColor="var(--secondary-background-color1)"
                />
              </div>
              <span className={styles.successText}>{text[status]}</span>

              <Button
                block
                shape="rounded"
                type="submit"
                color="primary"
                size="middle"
                className={styles.button}
                style={{
                  '--border-color': 'none',
                  '--background-color': 'var(--button-background-color)',
                  '--border-radius': 'var(--button-radius)',
                  '--text-color': 'var(--button-text-color)',
                  background:
                    'var(--background-color, var(--dpm-color-primary))',
                }}
                onClick={onView}
              >
                {payTrans('checkOrder', '查看订单')}
              </Button>
            </>
          ) : (
            <>
              <div className={styles.iconWrap}>
                <SvgErrorIcon
                  color="var(--primary-color)"
                  backgroundColor="var(--secondary-background-color1)"
                />
              </div>
              <span className={styles.successText}>{text[status]}</span>

              <Button
                block
                shape="rounded"
                type="submit"
                color="primary"
                size="middle"
                className={styles.button}
                // style={{ width: '335px', margin: '0 20px' }}
                onClick={() =>
                  // goTo(
                  //   backUrl
                  //     ? decodeURIComponent(backUrl)
                  //     : '/order/orderRecord?status=',
                  // )
                  goTo(
                    `/order/orderDetail?orderNo=${orderNo}&cpSource=${
                      orderDetail?.cpSource ?? ''
                    }&type=${orderDetail?.orderType ?? ''}`,
                  )
                }
                style={{
                  '--border-color': 'none',
                  '--background-color': 'var(--button-background-color)',
                  '--border-radius': 'var(--button-radius)',
                  '--text-color': 'var(--button-text-color)',
                  background:
                    'var(--background-color, var(--dpm-color-primary))',
                }}
              >
                {promptTrans('goBack', '返回')}
              </Button>
            </>
          )}
        </div>
      )}
    </Layout>
  )
}

export default Result
